export const environment = {
    production: true,
    env: 'dev',
    baseDomain: 'dev.vizorro.ru',
    urls: {
        app: 'https://app.dev.vizorro.ru',
        api: 'https://api.dev.vizorro.ru',
        auth: 'https://auth.dev.vizorro.ru',
    },
};

export function sendBugReport(error: any): void {
    const cmpName = error?.ngDebugContext?.component?.__TAG
        ? error.ngDebugContext.component.__TAG
        : (error?.ngDebugContext?.component?.constructor?.name ? error.ngDebugContext.component.constructor.name : '<UnknownComponent>');
}

import 'zone.js/plugins/zone-error';
